import { gql, useReactiveVar } from "@apollo/client";
import { useMarkFulfillmentFulfilledMutation, useArchiveFulfillmentMutation } from "../types";
import { fulfillmentScreenSendNotificationVar } from "./FulfillmentScreenFunctions";
gql `
mutation MarkFulfillmentFulfilled($id: ID!, $sendNotification: Boolean) {
  fulfillmentMarkFulfilled(id: $id, sendNotification: $sendNotification) {
    ...FulfillmentLine
  }
}

mutation ArchiveFulfillment($id: ID!) {
  fulfillmentArchive(id: $id) {
    ...FulfillmentLine
  }
}
`;
export const useArchiveFulfillment = (id) => {
    const [original, result] = useArchiveFulfillmentMutation({
        variables: {
            id,
        }
    });
    const wrapped = () => {
        original({
            optimisticResponse: {
                __typename: "Mutation",
                fulfillmentArchive: {
                    __typename: "Fulfillment",
                    id,
                    productSelections: [],
                }
            },
            update: (cache, { data }) => {
                var _a, _b;
                if ((_a = data === null || data === void 0 ? void 0 : data.fulfillmentArchive) === null || _a === void 0 ? void 0 : _a.isArchived) {
                    cache.writeFragment({
                        id: `Fulfillment:${(_b = data === null || data === void 0 ? void 0 : data.fulfillmentArchive) === null || _b === void 0 ? void 0 : _b.id}`,
                        fragment: gql `
              fragment MarkArchived on Fulfillment {
                isArchived
              }
            `,
                        data: data.fulfillmentArchive,
                    });
                }
            }
        });
    };
    return { wrapped, original, result };
};
export const useMarkFulfillmentFulfilled = (id) => {
    const fulfillmentScreenSendNotification = useReactiveVar(fulfillmentScreenSendNotificationVar);
    const [original, result] = useMarkFulfillmentFulfilledMutation({
        variables: {
            sendNotification: fulfillmentScreenSendNotification,
            id,
        }
    });
    const wrapped = () => {
        original({
            optimisticResponse: {
                __typename: "Mutation",
                fulfillmentMarkFulfilled: {
                    __typename: "Fulfillment",
                    id,
                    isFulfilled: true,
                    productSelections: [],
                }
            },
            update: (cache, { data }) => {
                var _a, _b;
                if ((_a = data === null || data === void 0 ? void 0 : data.fulfillmentMarkFulfilled) === null || _a === void 0 ? void 0 : _a.isFulfilled) {
                    cache.writeFragment({
                        id: `Fulfillment:${(_b = data === null || data === void 0 ? void 0 : data.fulfillmentMarkFulfilled) === null || _b === void 0 ? void 0 : _b.id}`,
                        fragment: gql `
              fragment MarkFulfilled on Fulfillment {
                isFulfilled
              }
            `,
                        data: data.fulfillmentMarkFulfilled,
                    });
                }
            }
        });
    };
    return { wrapped, original, result };
};
